<article-form-feature [article]="article" (articleSubmit)="onSubmit($event)"></article-form-feature>